var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCircularArrowBackwards = function SvgCircularArrowBackwards(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 2.5a1.5 1.5 0 0 0-3 0V10h6.5a1.5 1.5 0 0 0 0-3H5.346a5.617 5.617 0 0 1 4.994-3c3.095 0 5.604 2.462 5.604 5.5S13.435 15 10.34 15a5.633 5.633 0 0 1-4.178-1.834 1.548 1.548 0 0 0-2.158-.117 1.48 1.48 0 0 0-.12 2.118A8.714 8.714 0 0 0 10.339 18C15.122 18 19 14.194 19 9.5S15.122 1 10.339 1A8.712 8.712 0 0 0 4 3.709V2.5z"
  })));
};
export default SvgCircularArrowBackwards;